import { render, staticRenderFns } from "./metrics_student_filters.vue?vue&type=template&id=07fe362c&scoped=true&"
import script from "./metrics_student_filters.vue?vue&type=script&lang=js&"
export * from "./metrics_student_filters.vue?vue&type=script&lang=js&"
import style0 from "./metrics_student_filters.vue?vue&type=style&index=0&id=07fe362c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe362c",
  null
  
)

export default component.exports